<template>
  <v-list-item v-on="hasClickListener ? { click: () => $emit('click') } : {}">
    <slot name="icon"></slot>

    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        <a v-if="hasOpenDetailListener" @click.stop="emitOpenDetail">
          {{ item.titleReadable }}
        </a>
        <span v-else> {{ item.titleReadable }} </span>
        <span v-if="item.externalId">({{ item.externalId }})</span>
      </v-list-item-title>
      <v-list-item-subtitle v-if="!small" class="text-truncate text-xs">
        <span v-if="item.emails[0]">
          <v-icon x-small>mdi-email</v-icon>
          {{ item.emails[0].email }}
        </span>

        <span v-if="item.phones[0]">
          <v-icon x-small>mdi-phone</v-icon>
          {{ item.phones[0].phone }}
        </span>

        <span v-if="item.addresses[0]">
          <v-icon x-small>mdi-map-marker</v-icon>
          {{ item.addresses[0].street }}, {{ item.addresses[0].zip }} {{ item.addresses[0].city }}
          {{ item.addresses[0].state }}
        </span>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { PersonGoToHelper } from "@/lib/utility/person.go-to-helper";
import { IPerson } from "@/models/person.entity";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: {}
})
export default class RefsPerson extends BaseRef<IPerson> implements IRefDetail<IPerson> {
  @Prop()
  item!: IPerson;

  @Prop()
  small!: boolean;

  @Prop()
  confirmable!: boolean;

  async goToDetail() {
    const partnerId = this.item.partnerId;
    const personId = this.item.id;
    const newTab = false;

    new PersonGoToHelper(this.$router).goToPersonDetail({ personId, partnerId, newTab });
  }
}
</script>
